module.exports = __webpack_public_path__ + "747f038d3190ec1002b6dd0895c23dcc.png";